import styled from 'styled-components';

export const Title = styled.span`
  color: ${({ theme }) => theme.color.additional.alwaysWhite.value};
  line-height: 1.2;
  font-weight: 900;
  font-size: 44px;
  letter-spacing: -2px;
  font-family: Roboto;
  a {
    text-decoration: none;
  }
  font-weight: 900;
  &:hover {
    cursor: pointer;
  }
`;
